import { Controller } from '@hotwired/stimulus';

/**
 * Edits a value in place, in a Turbo frame that swaps the value for a form and back. The field comes in
 * focused with its text selected, Escape cancels, and a cancel gives the focus back to the edit button.
 */
export default class extends Controller {
    static targets = ['edit', 'input', 'cancel'];

    inputTargetConnected(input) {
        this.isEditing = true;

        // After a failed save the form-errors controller focuses the field
        if (!input.classList.contains('is-invalid')) {
            input.focus();
            input.select();
        }
    }

    editTargetConnected(button) {
        if (this.isEditing) {
            this.isEditing = false;
            button.focus();
        }
    }

    cancel() {
        if (this.hasCancelTarget) {
            this.cancelTarget.click();
        }
    }
}
